import { __ } from '@wordpress/i18n';
import {VayuBlocksBorder} from '@vayu-blocks';

export const Radiuscontrol = ({onChange,dataKey,frameData}) => {

    const handleBorderChangeTest = (frameData, newBorders) => {

        const updatedAttributes = {
            ...frameData,
            radius: {
                ...newBorders,
            },
        };

        onChange(dataKey, updatedAttributes); 
    };
    
  return (
        <div className="vb-border-radius-cont">
            <VayuBlocksBorder
                onChange={(key, value) => handleBorderChangeTest(frameData, value)}
                borderRadius={{ key: 'radius', value: frameData?.radius }}
                label = {{border:'Radius'}}
            />
        </div>
  )
}

 